import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { getService } from "../../data/services";
import { DEPOSIT, prettyDate } from "../../data/booking";

export const SummaryRows = ({ form }) => {
  const s = getService(form.serviceId);
  const styleLine =
    [form.size, form.length, form.color && `#${form.color}`]
      .filter(Boolean)
      .join(" • ") || "—";
  return (
    <dl className="space-y-3 text-sm">
      {[
        ["Service", s ? s.name : "—"],
        ["Style", styleLine],
        ["Date", prettyDate(form.date) || "—"],
        ["Time", form.time || "—"],
      ].map(([k, v]) => (
        <div key={k} className="flex items-baseline justify-between gap-4">
          <dt className="text-[10px] uppercase tracking-[0.25em] text-white/40">
            {k}
          </dt>
          <dd className="text-right text-white/85">{v}</dd>
        </div>
      ))}
      <div className="mt-2 space-y-3 border-t border-white/10 pt-4">
        <div className="flex items-baseline justify-between">
          <dt className="text-[10px] uppercase tracking-[0.25em] text-white/40">
            Est. price
          </dt>
          <dd className="font-serif text-lg text-white">
            {s ? `$${s.price}` : "—"}
          </dd>
        </div>
        <div className="flex items-baseline justify-between">
          <dt className="text-[10px] uppercase tracking-[0.25em] text-white/40">
            Deposit due today
          </dt>
          <dd className="font-serif text-lg text-hotpink">${DEPOSIT}</dd>
        </div>
        <div className="flex items-baseline justify-between">
          <dt className="text-[10px] uppercase tracking-[0.25em] text-white/40">
            Balance at visit
          </dt>
          <dd className="text-white/85">{s ? `$${s.price - DEPOSIT}` : "—"}</dd>
        </div>
      </div>
    </dl>
  );
};

export const Summary = ({ form }) => (
  <aside
    className="sticky top-24 hidden h-fit rounded-3xl border border-white/10 bg-coal p-7 lg:block"
    data-testid="booking-summary"
  >
    <h3 className="mb-5 font-serif text-xl">Your Appointment</h3>
    <SummaryRows form={form} />
    <p className="mt-6 text-[11px] leading-relaxed text-white/35">
      Prototype preview — availability and pricing are sample data. The live
      booking engine (Jotform) will power this summary in production.
    </p>
  </aside>
);

export const MobileSummary = ({ form }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="rounded-2xl border border-white/10 bg-coal lg:hidden"
      data-testid="booking-summary-mobile"
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        data-testid="booking-summary-toggle"
        className="flex w-full items-center justify-between px-5 py-4 text-[11px] font-bold uppercase tracking-[0.25em] text-white/80"
      >
        Booking summary
        <ChevronDown
          className={`h-4 w-4 text-hotpink transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <div className="border-t border-white/10 p-5">
          <SummaryRows form={form} />
        </div>
      )}
    </div>
  );
};

